// Module
var code = "<div class=\"modal-header\"> <h3 class=\"modal-title\">Work Order Completed</h3> </div> <div class=\"modal-footer\"> <div class=\"col-xs-12 text-center\"> <button class=\"btn btn-secondary\" type=\"button\" ng-click=\"ModalApply()\"> <span> CONFIRM </span> </button> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'work-orders/Pages/Modals/modalCompleted.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;